import { Controller } from '@hotwired/stimulus';
import { TurboModalController } from 'controllers/common/turbo_modal_controller';

export default class extends Controller {
  connect() {}

  open({ params }) {
    TurboModalController.openModal(params.modalId);
  }

  close({ params }) {
    TurboModalController.closeModal(params.modalId);
  }
}
